import React from "react";

export default function Footer() {
  const currentYear = new Date().getFullYear();

  return (
    <footer
      className="position-relative overflow-hidden pt-5 pb-4 mt-5"
      style={{
        background: "linear-gradient(135deg, #0f172a 0%, #111827 100%)",
      }}
    >
      <div className="container position-relative">
        {/* Top Section */}
        <div className="row g-5 pb-5">
          {/* Brand Section */}
          <div className="col-lg-4 col-md-6">
            <div className="mb-4">
              <h4 className="fw-bold text-white d-flex align-items-center mb-3">
                <span className="footer-logo me-3">
                  <i className="bi bi-droplet-fill"></i>
                </span>
                SOCIETY FOR THE "WATER"
              </h4>

              <p className="text-light-emphasis footer-text">
                Established on February 12, 1996. SFW is dedicated to
                sustainable livelihood development, skill enhancement,
                social empowerment, and long-term community impact
                through structured intervention programs.
              </p>
            </div>

            {/* Tags */}
            <div className="d-flex flex-wrap gap-2">
              <span className="footer-badge">
                <i className="bi bi-calendar-event me-1"></i>
                ESTD. 1996
              </span>

              <span className="footer-badge footer-badge-warning">
                <i className="bi bi-award me-1"></i>
                ISO 9001:2008 Certified
              </span>
            </div>
          </div>

          {/* Navigation */}
          <div className="col-lg-2 col-md-6 col-6">
            <h6 className="footer-heading">Quick Links</h6>

            <ul className="list-unstyled d-flex flex-column gap-3">
              <li>
                <a href="#about" className="footer-link">
                  About Us
                </a>
              </li>

              <li>
                <a href="#focus-areas" className="footer-link">
                  Focus Areas
                </a>
              </li>

              <li>
                <a href="#projects" className="footer-link">
                  Projects
                </a>
              </li>

              <li>
                <a href="#performance" className="footer-link">
                  Performance
                </a>
              </li>

              <li>
                <a href="#financials" className="footer-link">
                  Financials
                </a>
              </li>

              <li>
                <a href="#team" className="footer-link">
                  Leadership
                </a>
              </li>
            </ul>
          </div>

          {/* Locations */}
          <div className="col-lg-3 col-md-6 col-6">
            <h6 className="footer-heading">Operational Presence</h6>

            <ul className="list-unstyled d-flex flex-column gap-3 text-light-emphasis">
              <li className="footer-location">
                <i className="bi bi-geo-alt-fill text-danger"></i>
                Uttar Pradesh
              </li>

              <li className="footer-location">
                <i className="bi bi-geo-alt-fill text-primary"></i>
                Madhya Pradesh
              </li>

              <li className="footer-location">
                <i className="bi bi-geo-alt-fill text-success"></i>
                Maharashtra
              </li>

              <li className="footer-location">
                <i className="bi bi-geo-alt-fill text-warning"></i>
                Rajasthan
              </li>

              <li className="footer-location">
                <i className="bi bi-geo-alt-fill text-info"></i>
                Uttarakhand
              </li>

              <li className="footer-location">
                <i className="bi bi-geo-alt-fill text-secondary"></i>
                Punjab & Bihar
              </li>
            </ul>
          </div>

          {/* Compliance */}
          <div className="col-lg-3 col-md-6">
            <h6 className="footer-heading">Compliance & Registration</h6>

            <div className="footer-card">
              <div className="compliance-item">
                <div className="compliance-icon bg-warning bg-opacity-10 text-warning">
                  <i className="bi bi-bank2"></i>
                </div>

                <div>
                  <h6 className="text-white mb-1 fw-semibold">
                    MHA Registered
                  </h6>

                  <small className="text-light-emphasis">
                    Ministry of Home Affairs
                  </small>
                </div>
              </div>

              <hr className="border-secondary border-opacity-25 my-3" />

              <div className="compliance-item">
                <div className="compliance-icon bg-info bg-opacity-10 text-info">
                  <i className="bi bi-file-earmark-check"></i>
                </div>

                <div>
                  <h6 className="text-white mb-1 fw-semibold">
                    Income Tax Compliance
                  </h6>

                  <small className="text-light-emphasis">
                    Registered Status
                  </small>
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="footer-bottom border-top border-secondary border-opacity-25 pt-4">
          <div className="row align-items-center g-3">
            <div className="col-md-6 text-center text-md-start">
              <p className="mb-0 text-light-emphasis small">
                © {currentYear}{" "}
                <span className="text-white fw-semibold">
                  SOCIETY FOR THE "WATER"
                </span>
                . All Rights Reserved.
              </p>
            </div>

            <div className="col-md-6 text-center text-md-end">
              <span className="small text-light-emphasis">
                <i className="bi bi-shield-check text-success me-2"></i>
                ISO 9001:2008 Certified Non-Profit Organization
              </span>
            </div>
          </div>
        </div>
      </div>

      {/* Background Blur Elements */}
      <div className="footer-blur footer-blur-1"></div>
      <div className="footer-blur footer-blur-2"></div>

      {/* Custom CSS */}
      <style>{`
        .footer-logo {
          width: 52px;
          height: 52px;
          border-radius: 16px;
          background: rgba(59, 130, 246, 0.12);
          display: flex;
          align-items: center;
          justify-content: center;
          color: #3b82f6;
          font-size: 1.3rem;
          animation: pulseSlow 3s infinite;
        }

        .footer-heading {
          color: white;
          font-weight: 700;
          margin-bottom: 1.5rem;
          font-size: 0.95rem;
          text-transform: uppercase;
          letter-spacing: 1px;
        }

        .footer-text {
          line-height: 1.8;
          font-size: 0.95rem;
        }

        .footer-link {
          color: rgba(255,255,255,0.7);
          text-decoration: none;
          transition: all 0.25s ease;
          display: inline-block;
          font-size: 0.95rem;
        }

        .footer-link:hover {
          color: #60a5fa;
          transform: translateX(4px);
        }

        .footer-location {
          display: flex;
          align-items: center;
          gap: 0.7rem;
          font-size: 0.95rem;
        }

        .footer-card {
          background: rgba(255,255,255,0.04);
          border: 1px solid rgba(255,255,255,0.08);
          border-radius: 20px;
          padding: 1.25rem;
          backdrop-filter: blur(10px);
        }

        .compliance-item {
          display: flex;
          align-items: flex-start;
          gap: 1rem;
        }

        .compliance-icon {
          width: 48px;
          height: 48px;
          border-radius: 14px;
          display: flex;
          align-items: center;
          justify-content: center;
          font-size: 1.2rem;
          flex-shrink: 0;
        }

        .footer-badge {
          background: rgba(255,255,255,0.08);
          border: 1px solid rgba(255,255,255,0.08);
          color: rgba(255,255,255,0.85);
          padding: 0.5rem 0.9rem;
          border-radius: 999px;
          font-size: 0.75rem;
          display: inline-flex;
          align-items: center;
        }

        .footer-badge-warning {
          background: rgba(255, 193, 7, 0.1);
          color: #facc15;
          border-color: rgba(255, 193, 7, 0.2);
        }

        .footer-bottom {
          position: relative;
          z-index: 2;
        }

        .footer-blur {
          position: absolute;
          border-radius: 50%;
          filter: blur(100px);
          opacity: 0.12;
          z-index: 0;
        }

        .footer-blur-1 {
          width: 220px;
          height: 220px;
          background: #2563eb;
          top: -50px;
          left: -50px;
        }

        .footer-blur-2 {
          width: 260px;
          height: 260px;
          background: #9333ea;
          bottom: -100px;
          right: -100px;
        }

        @keyframes pulseSlow {
          0%, 100% {
            transform: scale(1);
            opacity: 1;
          }

          50% {
            transform: scale(1.05);
            opacity: 0.8;
          }
        }

        @media (max-width: 768px) {
          .footer-heading {
            margin-top: 1rem;
          }

          .footer-text {
            font-size: 0.9rem;
          }
        }
      `}</style>
    </footer>
  );
}